import { useQuery } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'

import api, { withAuthenticatedRequest } from '@/lib/api'

export function useFetchProductById(id_client: string | undefined) {
  const token = useAccessToken()

  return useQuery({
    queryKey: ['product', id_client],
    queryFn: async () => {
      if (!id_client) throw new Error('ID do produto não fornecido')

      const summaryResponse = await api.get(
        `/products/client/${id_client}/summary`,
        withAuthenticatedRequest(token, {
          validateStatus: status => status === 200 || status === 404
        })
      )

      if (summaryResponse.status === 200) {
        return summaryResponse.data?.data ?? []
      }

      const legacyResponse = await api.get(
        `/products/${id_client}`,
        withAuthenticatedRequest(token, {
          validateStatus: status => status === 200 || status === 404
        })
      )

      if (legacyResponse.status === 200) {
        return legacyResponse.data?.data ?? []
      }

      return []
    },
    enabled: Boolean(token && id_client),
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000
  })
}
